/* tslint:disable */
export var icon = "\n<svg width=\"10\" height=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0h2v16H4V0zM0 4h2v12H0V4zm10 3H8v9h2V7z\" fill=\"#3899EC\"/></svg>\n";
//# sourceMappingURL=article-summary.svg.js.map